import { fetchData } from "./apiHelpers";
import { ContainerListResponse } from "./container.type";

export function getContainers(): Promise<ContainerListResponse> {
  const url = process.env.REACT_APP_CONTAINER_API_URL + "/containers";

  const request = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
    },
  };

  return fetchData<ContainerListResponse>(url, request);
}
